import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import SubAccountOverview from './SubAccountOverview';
import TransactionsHistory from './Transactions/TransactionsHistory';
import useFetchSubAccounts from '@/hooks/useApi/useFetchSubAccounts';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Title } = vp;

type FC = FunctionComponent;

type DataProps = {
  account: vp.SubAccount;
};

const SubAccountDetailsContainer: FC = () => {
  const location = useLocation<DataProps>();
  const { state } = location;
  const { AccountID, Currency } = useParams<{ AccountID: string; Currency: string }>();
  const [subAccountsResponse, fetchSubAccounts] = useFetchSubAccounts({});
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.Details' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const history = useHistory();

  useEffect(() => {
    fetchSubAccounts({
      SubaccountID: AccountID,
      ShowToken: true,
      Limit: 20,
    });
  }, []);

  const account: vp.SubAccount | undefined = subAccountsResponse.Subaccounts?.[0] || state?.account;

  return (
    <>
      {account && (
        <Box flx="col">
          <Box flx="col" mb="md" gapSize="16px">
            <UtilButton
              iconLeft="chevron_left"
              size="large"
              onClick={() => {
                if (history.length > 1) {
                  history.goBack();
                } else {
                  history.replace('/sub-accounts-list');
                }
              }}
            >
              {history.length > 1 ? tGlobal('Buttons.back') : t('backButtonTitle')}
            </UtilButton>
            <Title title={t('title')} />
          </Box>
          {account && <SubAccountOverview account={account} currency={Currency} />}
          {account && (
            <TransactionsHistory
              accountId={account?.AccountID}
              subAccountType={account?.SubAccountType}
              currency={Currency}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default SubAccountDetailsContainer;
